var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner(args) {
        var _this = _super.call(this, args) || this;
        _this.name = "spinner";
        _this.container = typeof (args === null || args === void 0 ? void 0 : args.container) === "string" ? document.querySelector(args === null || args === void 0 ? void 0 : args.container) : args === null || args === void 0 ? void 0 : args.container;
        _this.composer = args === null || args === void 0 ? void 0 : args.composer;
        return _this;
    }
    Spinner.prototype.render = function () {
        //spinner is purely an element no instantiation needed, no options, no events, no methods
        this.setElement();
        if (this.container) {
            this.container.classList.add('position-relative');
            this.container.appendChild(this.element);
        }
        else {
            return this.element;
        }
    };
    return Spinner;
}(Component));
export { Spinner };
